import Const from 'Utils/Consts'
import { addBasicData, deleteBasicData, getBasicDataById } from 'DataBase/BasicDataDB'

export async function getCache(cacheKey: string): Promise<any> {
  var cacheData = await getBasicDataById(cacheKey)
  if (cacheData) {
    if (cacheData.lastUpdate) {
      const nowTime = new Date().getTime()
      if (
        nowTime - new Date(String(cacheData.lastUpdate)).getTime() <
        Const.env.REACT_APP_VISIT_CACHE_EXPIRE_TIME_IN_SECONDS * 1000
      ) {
        return JSON.parse(cacheData.data)
      }
    }
    await deleteBasicData(cacheKey)
  }
  return undefined
}

export async function setCache(cacheKey: string, data: any) {
  await addBasicData(cacheKey, JSON.stringify(data))
}
